import { keyframes } from '@mui/material/styles';

export const authFormEntrance = keyframes`
  from { opacity: 0.85; }
  to { opacity: 1; }
`;
